import React from "react";
import { Box, Typography } from "@mui/material";

const CartSummaryBreakdown = ({
  subtotal,
  totalDiscount,
  total,
  showTaxNote = true,
}) => {
  return (
    <Box>
      {/* Subtotal */}
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        sx={{ mt: 0.5, fontSize: "1.1rem" }}>
        Subtotal: ${subtotal.toFixed(2)} CAD
      </Typography>

      {/* Discount */}
      {totalDiscount > 0 && (
        <Typography
          variant="body2"
          color="success.main"
          sx={{ fontWeight: 500 }}>
          Discount: -${totalDiscount.toFixed(2)}
        </Typography>
      )}

      {/* Tax Notice */}
      {showTaxNote && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontStyle: "italic", display: "block", mt: 0.5 }}>
          Taxes and fees calculated at checkout
        </Typography>
      )}
    </Box>
  );
};

export default CartSummaryBreakdown;
